import React, { FC } from 'react';
import { Col, Row, Typography } from 'antd';
import styled from 'styled-components';
import cx from 'classnames';

import { ChangeLanguage, PrivacyPolicyFooter, Space } from '~/components';
import theme from '~/theme';
import GoToLoginButton from './GoToLoginButton';
import { LogoWithTextImg } from '~/img';

interface Props {
  title?: string;
  subtitle?: string;
  icon?: JSX.Element;
  withGoToLogin?: boolean;
}

const PasswordResetLayout: FC<Props> = (props) => {
  const { title, subtitle, icon, withGoToLogin, children } = props;
  return (
    <>
      <ChangeLanguage />
      <Container>
        <Row justify="center" align="middle" className="PasswordResetLayout-LogoRow">
          <Col>
            <LogoWithTextImg />
          </Col>
        </Row>
        <Row justify="center" align="top" className="PasswordResetLayout-Row">
          <Col flex="0 1 400px">
            <div className="PasswordResetLayout-Card">
              {withGoToLogin && (
                <div className="PasswordResetLayout-GoBackContainer">
                  <GoToLoginButton />
                </div>
              )}
              <Space size={24} direction="vertical" align="center">
                {icon && (
                  <icon.type
                    {...icon.props}
                    className={cx(icon.props.className, 'PasswordResetLayout-Icon')}
                  />
                )}
                {title && (
                  <Typography.Title className="PasswordResetLayout-Title" level={2}>
                    {title}
                  </Typography.Title>
                )}
                {subtitle && (
                  <Typography.Text type="secondary" className="PasswordResetLayout-Subtitle">
                    {subtitle}
                  </Typography.Text>
                )}
                {children}
              </Space>
            </div>
          </Col>
        </Row>
      </Container>
      <Row gutter={[0, 16]} justify="center" align="middle">
        <Col>
          <PrivacyPolicyFooter />
        </Col>
      </Row>
    </>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 16px 0;

  .PasswordResetLayout-LogoRow {
    height: calc(100vh * 0.2);

    img {
      width: 200px;
    }
  }

  .PasswordResetLayout-Row {
    height: 100%;

    .PasswordResetLayout-Card {
      max-width: 400px;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 48px 24px;
      background-color: ${theme.layoutHeaderBackground};
      box-shadow: 0 2px 6px rgb(0 0 0 / 4%);
      border-radius: 4px;

      .PasswordResetLayout-GoBackContainer {
        margin-top: -24px;
        margin-bottom: 40px;
        display: flex;
        width: 100%;
      }

      .PasswordResetLayout-Icon {
        font-size: 72px;
        color: ${theme.primaryColor};
      }

      .PasswordResetLayout-Title {
        margin-bottom: 0;
        word-break: break-word;
        text-align: center;
      }

      .PasswordResetLayout-Subtitle {
        text-align: center;
        display: flex;
      }

      .ant-form,
      .ant-card {
        width: 350px;
        @media (max-width: 400px) {
          width: 100%;
        }
      }

      .PasswordResetLayout-ButtonContainer {
        display: flex;
        justify-content: center;
      }
    }
  }
`;

export default PasswordResetLayout;
